// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__SGVgB","form":"styles_form__2HOMI"};